import React from "react";
import { Box, Radio, Typography, FormHelperText } from "@mui/material";
import FormLabel from "../../Components/Form/FormLabel"; // ✅ fixed import (remove { } if it's default export)

const RadioBoxField = ({
  name,
  formlabel,
  label,
  value,
  checked,
  onChange,
  error = false,
  helperText = "",
  gap = 1.5,
  sx = {},
  required = false,
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap, ...sx }}>
      {/* Optional Form Label */}
      {formlabel && (
        <FormLabel label={formlabel} gap={gap} required={required} />
      )}

      {/* Radio Button */}
      <Radio
        checked={checked}
        onChange={() => onChange(value)}
        value={value}
        name={name}
        size="small"
        sx={{
          color: error ? "var(--red-800)" : undefined,
          p: 0,
          "&.Mui-checked": {
            color: "var(--brand-600)",
          },
        }}
      />

      {/* Radio Label */}
      {label && (
        <Typography fontSize={14} sx={{ userSelect: "none" }}>
          {label}
        </Typography>
      )}

      {/* Helper / Error Text */}
      {helperText && (
        <FormHelperText
          sx={{
            color: error ? "var(--red-800)" : "text.secondary",
            ml: 4,
          }}
        >
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default RadioBoxField;
